import { IoClose } from 'react-icons/io5';
import { COLOR } from '../../../config/constraits';

interface FilterChipProps {
  label: string;
  value: string;
  onRemove: () => void;
}

export default function SelectedFilterChip({ label, value, onRemove }: FilterChipProps) {
	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				gap: "6px"
			}}
		>
			<span>{label}</span>

			<div
				style={{
				borderRadius: "8px",
				backgroundColor: "#F5F5F5",
				padding: "0px 30px 0px 8px",
				position: "relative",
				overflow: "hidden",
				border: `2px solid ${COLOR.FILTER}`,
				display: "flex",
				alignItems: "center" 
				}}
			>
				{value}

				<button
					style={{
						position: "absolute",
						right: 0,
						top: "50%",              
						transform: "translateY(-50%)",
						padding: "2px",
						backgroundColor: COLOR.FILTER,
						border: "none"
					}}
					onClick={onRemove}
				>
					<IoClose style={{ fontSize: "20px", color: "#F5F5F5" }} />
				</button>
			</div>
		</div>
	);
}
